<template>
  <div class="full-width">
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Cartera</li>
      </template>
      <template slot="title">
        Conoce la evolución y mejora de nuestra <span class="bold">cartera</span>.
      </template>
      <template slot="body">
        <!-- <Body/> -->
        <Wallet v-if="rgStats != null" :rgStats="rgStats" :isMounted="rgStats != null"/>
        <WalletStatus v-if="rgStats != null" :rgStats="rgStats" :isMounted="rgStats != null"/>
      </template>
    </GenericPage>
  </div>
</template>

<script>
import Body from "@components/past-due-portfolio/Body";
import GenericPage from "./new-portal-views/GenericPage.vue";
import Wallet from "../components/landing-components/for-past-due-portfolio/Wallet.vue";
import WalletStatus from "../components/landing-components/for-past-due-portfolio/WalletStatus.vue";

export default {
  name: "pastDuePortfolio",
  components: {
    Body,
    GenericPage,
    Wallet,
    WalletStatus
  },
  data() {
    return {
      rgStats: null,
      isMounted: false
    }
  },
  async mounted() {
    await this.RgStats();
  },
  methods: {
    async RgStats() {
      this.isMounted = false;
      this.rgStats = await this.setRgStatsData();
      this.isMounted = true;
      this.$forceUpdate();
    }
  }
}
</script>

<style scoped></style>